import {makeStyles} from '@mui/styles'

import {KEYRUS_AI_BANNER_HEIGHT_CSS_VAR} from 'helpers/keyrusAi'

const useStyles = makeStyles(({breakpoints, layout, palette}) => ({
  container: {
    height: layout.header.height,
    position: 'fixed!important',
    top: `var(${KEYRUS_AI_BANNER_HEIGHT_CSS_VAR}, 0px)`,
    left: 0,
    borderBottom: `1px solid ${palette.background.gray}`,
    fontFamily: 'CamptonLight',
    backgroundColor: palette.background.default,
    zIndex: 20,
    width: '100vw',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& > div': {
      maxWidth: 1300,
      width: '95%',
    },
    [breakpoints.down('sm')]: {
      height: layout.header.heightMobile,
    },
  },
}))

export default useStyles
